module.exports = __webpack_public_path__ + "static/img/32-1.2c02bf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/32-1.jpg
// module id = vPHi
// module chunks = 0